import styles from "../../css/heatmaps/TipsFromAnalysis.module.css";

const TipsFromAnalysis = () => {
  return (
    <div className={styles.tipsContainer}>
      <div className={styles.tipBox}>
        <h2>
          Celkové hodnocení banneru: <span className={styles.score}>3/10</span>
        </h2>
        <p>
          <strong>PermoniQ doporučuje:</strong> PermoniQ doporučuje zásadně
          přepracovat vizuální hierarchii banneru. Je nutné potlačit dominanci
          produktové fotografie a naopak výrazně zvýraznit CTA tlačítko pomocí
          kontrastní barvy a větší velikosti, aby se pozornost uživatele
          přesunula od prohlížení produktu k provedení konverzní akce.
        </p>
      </div>

      {/* konektor jako samostatná položka mezi boxy */}
      <span className={styles.connector} aria-hidden="true" />

      <div className={styles.tipBox}>
        <ul>
          <li>
            <strong>Logo:</strong> PermoniQ doporučuje zvážit mírné zmenšení
            loga nebo jeho přesunutí, aby nepřebíjelo hlavní nabídku.
          </li>
          <li>
            <strong>Claim:</strong> PermoniQ doporučuje vizuálně zvýraznit část
            '20% SLEVA' pomocí většího fontu, tučného řezu nebo kontrastnější
            barvy.
          </li>
          <li>
            <strong>CTA:</strong> PermoniQ doporučuje změnit barvu tlačítka na
            výrazně kontrastní (například zelenou z loga) a zvětšit jej pro
            maximální viditelnost.
          </li>
          <li>
            <strong>Podklad:</strong> PermoniQ doporučuje snížit vizuální
            dominanci obrázku sluchátek, například jeho zmenšením, mírným
            rozostřením nebo posunutím.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TipsFromAnalysis;
